import { useEffect, useRef } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import { baseExtensions, getMarkdown } from "@/components/rich/extensions";
import { RichToolbar } from "@/components/rich/RichToolbar";

export const RichEditor = ({ value, onChange, placeholder, disabled, className = "", testid = "rich-editor", minH = "min-h-[200px]", images = false, extra, onEditor }) => {
  const last = useRef(value);
  const editor = useEditor({
    extensions: baseExtensions({ placeholder, images }),
    content: value,
    editable: !disabled,
    editorProps: { attributes: { class: `lf-prose focus:outline-none px-4 py-3 ${minH} ${className}`, "data-testid": `${testid}-content` } },
    onUpdate: ({ editor: ed }) => { last.current = getMarkdown(ed); onChange(last.current); },
  });
  useEffect(() => {
    if (editor && value !== last.current) {
      last.current = value;
      editor.commands.setContent(value || "", false);
    }
  }, [editor, value]);
  useEffect(() => { editor?.setEditable(!disabled, false); }, [editor, disabled]);
  useEffect(() => { onEditor?.(editor); }, [editor, onEditor]);
  return (
    <div data-testid={testid}>
      {!disabled && <RichToolbar editor={editor} testid={`${testid}-toolbar`} extra={extra} />}
      <EditorContent editor={editor} />
    </div>
  );
};

export const RichView = ({ markdown, testid = "rich-view", className = "", images = false }) => {
  const editor = useEditor({ extensions: baseExtensions({ images }), content: markdown || "", editable: false, editorProps: { attributes: { class: `lf-prose ${className}`, "data-testid": testid } } }, [markdown]);
  return <EditorContent editor={editor} />;
};
